import { Toast } from 'zarm';
import axios from 'axios';
import { toParam, getQueryParam } from './tool';
axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.userId = 'CE3B2F86ADCAAC3A4FF96A42C12B0EC7200DD6D3A9BFBB47EA82193704204479C15CBE0E668AE57FA4F98EDB0C9CC856,22865';
axios.defaults.headers.flowType = '111'; // axios.defaults.headers['x-za-tenant'] = 'health';
// axios.defaults.headers['x-za-region'] = 'health';

axios.defaults.withCredentials = true;
axios.defaults.method = 'POST';
axios.defaults.baseURL = '/';
const prefix = '/api';
axios.interceptors.request.use(config => {
  const {
    from,
    tenantFrom = 'health'
  } = getQueryParam();

  if (config.requestType == 'form') {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
    config.data = toParam(config.data);
  }

  let qFrom = tenantFrom || from || '';

  if (from == 'ba') {
    qFrom = from;
  }

  config.headers['x-za-tenant'] = qFrom;
  config.headers['x-za-region'] = qFrom;
  return config;
});
axios.interceptors.response.use(res => {
  const {
    data
  } = res; // if (data && data.code === -100) {
  //   location.replace('/claim/login?backUrl=' + encodeURIComponent(window.location.href));
  //   logger.send({ type: 'loginexpired' })
  //   return Promise.reject({
  //     success: false,
  //     message: '未登录或者登陆失效，请重新登陆'
  //   })
  // }

  return data;
});

function request(url, options, noPrefix) {
  if (!noPrefix) {
    options.url = prefix + url;
  } else {
    options.url = url;
  }

  return axios(options).then(res => {
    // eslint-disable-next-line
    if (res.success === true) {} else if (options.failMuted !== true) {// showFailMessage(res);
    }

    return res;
  }).catch(error => {
    if (options.errorMuted !== true && error) {// showErrorMessage(error);
    }

    return Promise.reject(error);
  });
}

export function showErrorMessage(err) {
  let msg = '未知异常，请稍后再试';
  const {
    msg: message
  } = err;

  if (/Network Error/i.test(message)) {
    msg = '网络异常，请检查网络设置';
  } else if (/timeout/i.test(message)) {
    msg = '请求超时，请稍后再试';
  } else if (/Request failed with status code/i.test(message)) {
    msg = '系统异常';
  } else if (message) {
    msg = message;
  } // eslint-disable-next-line no-use-before-define


  showFailMessage({
    msg
  });
}
export function showFailMessage(res) {
  Toast.show(res.msg || '系统异常');
}
export default request;